import React from 'react';
import { PrepareEmailCampaign } from './prepare-email-campaign';

export const CampaignComponent = ({
  choosenCampaign,
  campaignFrequency,
  id,
  emailNotes,
  emailBudget,
  choosenEmailPlan,
  selectedTemplate,
  setSelectedTemplate,
  choosenTemplate,
  handleInnerFormChange,
  rowData,
  columnDefs,
  setPageData,
  customerTags,
  paginationData,
  vendorRowData,
  VendorpaginationData,
  vendorColumnDefs,
  agents
}: any) => {
  
  return (
    <>
      <PrepareEmailCampaign
        choosenCampaign={choosenCampaign}
        handleInnerFormChange={handleInnerFormChange} 
        campaignFrequency={campaignFrequency}
        customerTags={customerTags}
        emailNotes={emailNotes}
        emailBudget={emailBudget}
        choosenEmailPlan={choosenEmailPlan}   
        setSelectedTemplate={setSelectedTemplate}
        selectedTemplate={selectedTemplate}   
        choosenTemplate={choosenTemplate}
        id={id}
        rowData={rowData}
        columnDefs={columnDefs}
        setPageData={setPageData}
        paginationData={paginationData}
        vendorRowData={vendorRowData}
        VendorpaginationData={VendorpaginationData}
        vendorColumnDefs={vendorColumnDefs}
        agents={agents}
       />

     
    </>
  );
};
export default CampaignComponent;
